import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    opacity: 1,
    fontStyle: 'italic',
    fontSize: theme.size.xs
  },

  message: {
    opacity: 0.35,
    margin: '0px 1.25rem',
    borderRadius: '0 16px 16px',
    padding: '0.35rem 1rem',
    color: '#888888',
    backgroundColor: 'white',
    fontStyle: 'normal'
  },

  onChat: {
    opacity: 0.7,
    marginLeft: '2rem'
  }
}))

export default useStyles
